"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var AdminCalendarController = /** @class */ (function () {
    function AdminCalendarController($rootScope, $scope, CalendarService, DrivesFilterService, CalendarModel, $window, TimeoffRequestsModel, FlashService, VueStoreFactory) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.CalendarService = CalendarService;
        this.DrivesFilterService = DrivesFilterService;
        this.user = VueStoreFactory.dispatch("GET_USER").then(function (response) {
            _this.user = response;
        });
        this.CalendarModel = CalendarModel;
        this.$window = $window;
        this.TimeoffRequestsModel = TimeoffRequestsModel;
        this.FlashService = FlashService;
        this.entities = [];
        this.loading = false;
        this.calFullWidth = false;
        this.modalShown = false; //modal for RTOs
        this.rto = {}; //used for above modal
        this.updateEntities = this.updateEntities.bind(this);
        this.openRTOModal = this.openRTOModal.bind(this);
        this.closeRTOModal = this.closeRTOModal.bind(this);
        this.toggleCalFullWidth = this.toggleCalFullWidth.bind(this);
        this.deleteRTO = this.deleteRTO.bind(this);
        $rootScope.$on("UPDATE_CALENDAR", this.updateEntities);
        $scope.$on("OPEN_RTO_MODAL", this.openRTOModal);
        $rootScope.$on("CALENDAR_LOADING", function () {
            _this.loading = true;
        });
    }
    AdminCalendarController.prototype.updateEntities = function () {
        var entities = this.CalendarService.getCalendarItems();
        this.entities = entities;
        this.loading = false;
    };
    AdminCalendarController.prototype.openRTOModal = function (event, data) {
        this.modalShown = true;
        this.rto = data.event;
        this.rto.displayEnd = (0, time_1.subtractMinutes)(this.rto.end, 1); //to show proper date in modal display
    };
    AdminCalendarController.prototype.closeRTOModal = function () {
        this.modalShown = false;
        this.rto = {};
        this.CalendarService.getCalendarEvents({
            startDate: this.DrivesFilterService.getStartDate(),
            endDate: this.DrivesFilterService.getEndDate(),
            context: "admin",
        });
    };
    AdminCalendarController.prototype.deleteRTO = function (rto) {
        var _this = this;
        var confirmDelete = this.$window.confirm("Are you sure you want to delete this time off request? It cannot be undone.");
        if (!confirmDelete) {
            return;
        }
        var request = {
            id: rto.id,
        };
        this.TimeoffRequestsModel.delete(request).then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.closeRTOModal();
        });
    };
    AdminCalendarController.prototype.toggleCalFullWidth = function () {
        this.calFullWidth = !this.calFullWidth;
    };
    return AdminCalendarController;
}());
AdminCalendarController.$inject = [
    "$rootScope",
    "$scope",
    "CalendarService",
    "DrivesFilterService",
    "CalendarModel",
    "$window",
    "TimeoffRequestsModel",
    "FlashService",
    "VueStoreFactory",
];
exports.default = AdminCalendarController;
